// extracted by mini-css-extract-plugin
export default {"mainContainer":"KeyValueEditor_mainContainer__bMu-0","fontType":"KeyValueEditor_fontType__OtSjl","select":"KeyValueEditor_select__HRzpf"};